'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('dropdown', function (element) {

  var menuItems = [];

  var $dropdown = $(element),
    closeDropdown = function ($obj) {

      var activeLevel2Dd = $dropdown.find("div[class*='dropdown__items--level-2']").siblings("button[aria-expanded='true']").next();
      activeLevel2Dd.css("height", "auto"); // restoring back height of dropdown level 2 dropdown

      var $next = $obj.next();
      $obj.attr('aria-expanded', 'false');
      $next.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
        $next.css('margin', 0);
        $next.removeClass('is-expanded');
      });
    };

  $dropdown.on('click', 'button', function (e) {
    e.stopPropagation();
    var overlay = $('body').find("div[class*='overlay']");
    var dropdown = document.getElementsByClassName('dropdown')[0];

    dropdown.addEventListener("keyup", function (e) {
      if (e.type === "keyup" && e.key === "Escape") {
        $ul = $this.closest('ul');
        $ul.children().children("[aria-expanded=true]").attr("aria-expanded", "false");
        overlay.css('display', 'none');
        dropdown.removeEventListener("keyup", function (e) { });
      }
      else if (e.type === "keyup" && e.key === "ArrowDown") {
        dropdown.addEventListener("customEvent", arrowDown);
        var customEvent = new CustomEvent("customEvent", {
          "detail": { source: e.srcElement }
        });
        dropdown.dispatchEvent(customEvent);
        dropdown.removeEventListener("customEvent", arrowDown);
        dropdown.removeEventListener("keyup", function (e) { });
      }
      else if (e.type === "keyup" && e.key === "ArrowUp") {
        dropdown.addEventListener("customEvent", arrowUp);
        var customEvent = new CustomEvent("customEvent", {
          "detail": { source: e.srcElement }
        });
        dropdown.dispatchEvent(customEvent);
        dropdown.removeEventListener("customEvent", arrowUp);
        dropdown.removeEventListener("keyup", function (e) { });
      }
      else if (e.type === "keyup" && e.key === "ArrowRight") {
        toogleSubMenu(e.srcElement, "right");
        dropdown.addEventListener("customEvent", arrowRight);
        var customEvent = new CustomEvent("customEvent", {
          "detail": { source: e.srcElement }
        });
        dropdown.dispatchEvent(customEvent);
        dropdown.removeEventListener("customEvent", arrowRight);
        dropdown.removeEventListener("keyup", function (e) { });
      }
      else if (e.type === "keyup" && e.key === "ArrowLeft") {
        dropdown.addEventListener("customEvent", arrowLeft);
        var customEvent = new CustomEvent("customEvent", {
          "detail": { source: e.srcElement }
        });
        dropdown.dispatchEvent(customEvent);
        dropdown.removeEventListener("customEvent", arrowLeft);
        dropdown.removeEventListener("keyup", function (e) { });
      }
    })

    var $this = $(this),
      $ul = $this.closest('ul'),
      expanded = $this.attr('aria-expanded');

    var pressedButton = $(e.currentTarget);
    var bodyHeight = $('body').height();
    var isLevel2 = pressedButton.siblings("div[class*='dropdown__items--level-2']");
    var level2 = isLevel2.find("ul[class*='dropdown__items--level-2']");
    var level3 = isLevel2.find("ul[class*='dropdown__items--level-3']");
    var level4 = isLevel2.find("ul[class*='dropdown__items--level-4']");
    var isLevel4Active = level4.siblings("button");
    var innerDropdown = isLevel2.find("ul[class*='inner__dropdown']");
    var cookieInformation = $('body').find("div[class*='cookie-information']");
    var isCookieActive = cookieInformation.attr("aria-expanded");

    //Remove backdrop when menu is close
    if (expanded === 'true') {
      closeDropdown($this);
      if (isLevel2.length > 0) {
        overlay.css('display', 'none');
      }

      //Remove menu height
      if (isLevel4Active) {
        innerDropdown.css('height', 'auto');
      }
    }
    else {
      closeDropdown($ul.children().children("[aria-expanded=true]"));
      $this.attr('aria-expanded', 'true');

      //Add backdrop when menu is open
      //Top adjustment due to whether cookie information is displayed or not
      if (isLevel2.length > 0) {
        overlay.css('display', 'initial');
        overlay.css('height', bodyHeight);
      }
      if (isCookieActive) {
        overlay.css('top', '300px');
      }

      //Level 2
      var level2height = 0;
      if (level2.length == 1) {
        level2height = level2.first().height();
      }
      else if (level2.length > 1) {
        for (var i = 0; i < level2.length; i++) {
          if ($(level2[i]).height() > level2height)
            level2height = $(level2[i]).height();
        }
      }

      //Level 3
      var level3height = 0;
      if (level3.length == 1) {
        level3height = level3.first().height();
      }
      else if (level3.length > 1) {
        for (var i = 0; i < level3.length; i++) {
          if ($(level3[i]).height() > level3height)
            level3height = $(level3[i]).height();
        }
      }

      //Level 4
      var level4height = 0;
      if (level4.length == 1) {
        level4height = level4.first().height();
      }
      else if (level4.length > 1) {
        for (var i = 0; i < level4.length; i++) {
          if ($(level4[i]).height() > level4height)
            level4height = $(level4[i]).height();
        }
      }

      let allLevelHeight = Math.max(0, level2height, level3height, level4height);

      if (innerDropdown.height() < allLevelHeight) {
        innerDropdown.css('height', allLevelHeight);
      }

      var activeLevel2Dd;
      var activeLevel3Dd;
      var h2;
      var h3;
      var innerDropdown = $dropdown.find("ul[class*='inner__dropdown']");

      activeLevel2Dd = $dropdown.find("div[class*='dropdown__items--level-2']").siblings("button[aria-expanded='true']").next();
      h2 = activeLevel2Dd.height();

      if ($this.next().hasClass('dropdown__items--level-3')) //if level 3 is active
      {
        activeLevel3Dd = $this.next();
        h3 = activeLevel3Dd.height();
      }

      if (h3 > h2) {
        var gridBtmPadding = parseInt(activeLevel2Dd.find('.grid').first().css("padding-bottom"), 10);
        gridBtmPadding += 20;
        h3 += gridBtmPadding;

        activeLevel2Dd.css({
          'background-color': '#60646c',
          'height': h3
        });

      }

      var $next = $this.next(),
        offset = 15, // NOTE: The offset the dropdown will have from the window edge.
        transform = 60, // NOTE: The offset the dropdown has from translateX in order to animate.
        menuOffset = ($next.offset().left + $next.outerWidth() - $(window).width() + offset + transform);

      if (menuOffset > 0) {
        menuOffset += 'px';
        $next.css({
          zIndex: 2,
          marginLeft: '-' + menuOffset,
          marginRight: menuOffset
        });
        $next.addClass('is-expanded');
      }
    }

    if ($(window).scrollTop() > 140) {
      $(window).scrollTop(140);
    }
  });

  //Load menu to array (for arrow key navigation). Set key events to top menu items
  $(document).ready(function () {
    var menuElement = document.querySelector('.dropdown[data-component="dropdown"]');
    var menuItems = processMenu(menuElement);
    setArrowEvent(menuItems);
  });

  // Close dropdown
  $(document).click(function () {
    closeDropdown($dropdown.find(".megamenu > button[aria-expanded=true]"));

    //Removes overlay on click outside menu
    var overlay = $('body').find("div[class*='overlay']");
    overlay.css('display', 'none');
  });

  //Event when pressing arrow down key
  function arrowDown(e) {
    setFocusEvent(e, 'down');
  }

  //Event when pressing arrow up key
  function arrowUp(e) {
    setFocusEvent(e, 'up');
  }

  //Event when pressing arrow right key
  function arrowRight(e) {
    setFocusEvent(e, 'right');
  }

  //Event when pressing arrow left key
  function arrowLeft(e) {
    setFocusEvent(e, 'left');
  }

  //Event element helper func
  function setFocusEvent(e, direction) {
    e.stopPropagation();
    var sourceEl = e.detail.source;
    setFocus(sourceEl, direction)
  }

  //Set focus on correct link or button
  function setFocus(sourceEl, direction) {
    //Get source link
    var sourceId = sourceEl.getAttribute('data-contentlink-id');
    var sourceType = sourceEl.nodeName;

    //Get target link 
    var targetItem = getMenuItem(menuItems, null, sourceEl, sourceId, sourceType, direction, 0);
    if (targetItem) {
      setTimeout(() => targetItem.element.focus(), 50);
    }

    //Close submenu if left arrow
    if (targetItem && targetItem.code == "CloseSubMenu") {
      var expanded = targetItem.element.getAttribute('aria-expanded');
      if (expanded === "true") {
        targetItem.element.click();
        targetItem.code = null;
      }
    }
    //Close submenu if left arrow
    if (targetItem && targetItem.code == "CloseMainMenu") {
      var expanded = targetItem.element.getAttribute('aria-expanded');
      if (expanded === "true") {
        targetItem.element.click();
        targetItem.code = null;
      }
    }

  }

  //Get current menu item recursivly
  function getMenuItem(arr, parentItem, parentEl, id, type, direction, level) {
    level++;
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];

      if (item.contentLinkId == id && item.element.nodeName == type) {
        var currItem = getRequestedItem(arr, parentItem, parentEl, i, direction, level);
        return currItem;
      }
      else if (item.subMenu[0] && item.subMenu.length > 0) {
        const subItem = getMenuItem(item.subMenu, item, item.element, id, type, direction, level);
        if (subItem) {
          return subItem;
        }
      }
    }
  }

  //Extract current menu item
  function getRequestedItem(arr, parentItem, sourceEl, index, direction, level) {
    if (direction == "down" && level > 1 || (direction == "right" && level == 1)) {
      var nextIndex = parseInt(index) + 1;
      if (nextIndex < arr.length) {
        return arr[nextIndex];
      }
      else {
        return arr[0];
      }
    }
    else if (direction == "left" || direction == "up" && index == 0 && level == 2) {
      sourceEl.focus();
      if (direction == "up") {
        parentItem.code = "CloseMainMenu";
      }
      else {
        parentItem.code = "CloseSubMenu";
      }
      return parentItem;
    }
    else if (direction == "up" || (direction == "left" && level == 1)) {
      var prevIndex = parseInt(index) - 1;
      if (prevIndex < 0) {
        return arr[arr.length - 1];
      }
      else {
        return arr[prevIndex];
      }
    }
    else if (direction == "right" || (direction == "down" && level == 1)) {
      if (arr[index].subMenu.length > 0) {
        var menuI = arr[index].subMenu[0];
        if (menuI[0]) {
          return menuI[0];
        }
        else {
          return menuI;
        }
      }
    }
  }

  //Set arrow key event on top menu items
  function setArrowEvent(menuItems) {
    menuItems.forEach(function (item) {
      item.element.addEventListener('keydown', arrowUpTopItem);
      item.element.addEventListener('keyup', arrowDownTopItem);
    });
  }

  //Open/close submenu
  function toogleSubMenu(element, direction) {
    if (element.nodeName == "BUTTON") {
      var expanded = element.getAttribute('aria-expanded');
      if (expanded === 'false' && direction == 'right') {
        element.click();
        setFocus(element, direction);
      }
    }
  }

  //Prevent scolling when clicking down arrow key on top menu items
  function arrowUpTopItem(e) {
    if (e.key === "ArrowDown") {
      e.preventDefault();
    }
  }

  //Handle click on top menu item
  function arrowDownTopItem(e) {
    var element = e.srcElement;
    if (e.type === "keyup" && e.key === "ArrowDown") {
      var expanded = element.getAttribute('aria-expanded');
      if (expanded === 'false') {
        element.click();
        setFocus(element, 'down');
        e.stopPropagation();
        e.preventDefault();
      }
    }
    else if (e.type === "keyup" && e.key === "ArrowLeft") {
      var expanded = element.getAttribute('aria-expanded');
      if (expanded === 'true') {
        element.click();
      }
      setFocus(element, 'up');
      e.stopPropagation();
      e.preventDefault();
    }
    else if (e.type === "keyup" && e.key === "ArrowRight") {
      var expanded = element.getAttribute('aria-expanded');
      if (expanded === 'true') {
        element.click();
      }
      setFocus(element, 'right');
      e.stopPropagation();
      e.preventDefault();
    }
  }

  //Model for menu item
  function createMenuItem(label, code, contentLinkId, level, subMenu, element) {
    return {
      label: label || '',
      code: code || '',
      contentLinkId: contentLinkId || '',
      level: level || '',
      subMenu: subMenu || [],
      element: element || null
    };
  }

  //Load entire menu to array
  function processMenu(menuElement) {
    var level = 1;
    var topItems = document.querySelectorAll('.dropdown[data-component="dropdown"] > .dropdown__item');

    topItems.forEach(function (topItem) {
      var menuItem = null;
      var linkBtn = topItem.querySelector('.dropdown__button');
      if (linkBtn) {
        menuItem = createMenuItem(linkBtn.innerText.trim(), '', linkBtn.getAttribute('data-contentlink-id'), level, [], linkBtn);
      }

      var subItems = topItem.querySelectorAll('.inner__dropdown > .dropdown__item');
      var subItemArr = [];
      subItems.forEach(function (subMenuItem) {
        var subItem = processMenuItem(subMenuItem, level)
        if (subItem) {
          subItemArr.push(subItem);
        }
      });

      menuItem.subMenu = subItemArr;
      if (menuItem) {
        menuItems.push(menuItem);
      }
    });

    return menuItems;
  }

  //Load single menu item
  function processMenuItem(element, level) {
    var menuItem = null;

    // Extract label, link, and data-contentlink-id information
    var linkElem = element.querySelector('.dropdown__button');
    if (!linkElem)
      linkElem = element.querySelector('.dropdown__link');
    if (linkElem) {
      menuItem = createMenuItem(linkElem.querySelector('.link-text').textContent.trim(), '', linkElem.getAttribute('data-contentlink-id'), level, [], linkElem);
    }

    // Process sub-menu items if present
    var subMenuItems = element.querySelectorAll(':scope > .dropdown__items > .dropdown__item');
    if (subMenuItems) {
      subMenuItems.forEach(function (subMenuItem) {
        var pSubMenuItem = processMenuItem(subMenuItem, level++)
        if (pSubMenuItem) {
          menuItem.subMenu.push(pSubMenuItem);
        }
      });
    }

    return menuItem;
  }

});
